import { TipoDeRecurso } from '@/models/Recurso'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDePromocao: RouteConfig [] = [
	{
		path: 'promocoes',
		name: 'Cadastro de Promoções',
		components: {
			default: () =>
				import('@/views/application/promocoes/TelaDePromocoes.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'promocoes' as TipoDeRecurso,
		},
	},
]

export default rotasDePromocao